// Interest rate (% p.a.) by loan purpose — MUST match the backend
// src/config/loanRates.js. Placeholder rates; confirm with the business team.
export const LOAN_RATES = {
  defaultRate: 12,
  ratesByPurpose: {
    HOME_RENOVATION: 11,
    VEHICLE_PURCHASE: 11.5,
    EDUCATION: 12,
    BUSINESS_EXPANSION: 13,
    MEDICAL_EMERGENCY: 13.5,
    DEBT_CONSOLIDATION: 14
  }
};

export const getRateForPurpose = (loanPurpose) => {
  if (!loanPurpose) return LOAN_RATES.defaultRate;
  return LOAN_RATES.ratesByPurpose[loanPurpose] ?? LOAN_RATES.defaultRate;
};
